module.exports = __webpack_public_path__ + "img/bj_aboutus.c297b1a5.png";